export default __webpack_public_path__ + "static/media/undraw-design-team.cd58d380.svg";